import axios from 'axios';

const axiosClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10 * 60 * 1000,
});

axiosClient.interceptors.request.use(
  (config) => {
    const { accessToken } = JSON.parse(
      localStorage.getItem('okta-token-storage') || '{}'
    );

    if (accessToken?.accessToken) {
      config.headers = {
        ...config.headers,
        Authorization: `${accessToken.tokenType} ${accessToken.accessToken}`,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export default axiosClient;
